// Importar todas las imágenes del preview
import BANCAS_PREVIEW from './img/muebles-productos/BANCAS.png';
import ESQUINEROS_PREVIEW from './img/muebles-productos/ESQUINERO 5 REPISAS.png';
import FRUTEROS_PREVIEW from './img/muebles-productos/FRUTERO.png';
import MESAS_PREVIEW from './img/muebles-productos/MESA GRANDE.png';

// Exportar como objeto
export const imagenesPreview = {
  BANCAS: BANCAS_PREVIEW,
  ESQUINEROS: ESQUINEROS_PREVIEW,
  FRUTEROS: FRUTEROS_PREVIEW,
  MESAS: MESAS_PREVIEW
};

export default imagenesPreview;